import * as actions from './sexual-compatibility-actions';
import * as mutations from './sexual-compatibility-mutations';
import { state } from './sexual-compatibility-state';

export const sexualCompatibility = {
  state,
  mutations,
  actions,
};
